<div class="wrapper flex flex-col justify-between">
  <div class="heading text-type-5">
    {{ data?.heading }}
  </div>
  @if (data?.subheading) {
    <div
      class="subheading text-type-11"
      >
      {{ data.subheading }}
    </div>
  }
  @if (data?.subType !== 'bidItemWithMaterials') {
    <div
      [class.mb-[24px]]="data.subType === 'onlyMaterial'"
      class="subheading text-type-11 flex gap-[4px]"
      >
      <div class="label">{{ data.type === 'delivery' ? 'Received' : 'Used' }}:</div>
      <div class="value">{{ data.quantity }} {{ data.uom }}</div>
    </div>
  } @else {
    <div class="subheading text-type-11 flex gap-[4px]">
      {{ data.materials?.length }} Material{{ data.materials?.length === 1 ? '' : 's' }}
    </div>
  }
  @if (data?.type === 'delivery' && data?.map_feature_link?.sheet) {
    <!-- A linked sheet is a one-line chip on the tile; the record's side panel keeps the full card and Open sheet -->
    <app-design-context-chips [link]="data.map_feature_link" />
  } @else if (data?.type === 'delivery' && data?.map_feature_link) {
    <app-design-context class="card-design-context" [link]="data.map_feature_link" [editable]="false" [projectId]="projectId$ | async" />
  }
  @if (linkedMaterialCount) {
    <div class="card-linked-count text-type-14" data-testid="design-context-linked-count">{{ linkedCountText(linkedMaterialCount) }}</div>
  }
  @if (displayMatched) {
    <div class="matched text-type-15">{{ matchedNo }} {{ matchedNo > 1 ? 'occurrences' : 'occurrence' }}</div>
  }
</div>
